'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdminOneSchoolController = function () {
  function AdminOneSchoolController(school, fPrompt, msgService) {
    var _this = this;

    _classCallCheck(this, AdminOneSchoolController);

    this._ = { school: school, fPrompt: fPrompt, msgService: msgService };
    this.school = school;

    school.teachers().then(function (teachers) {
      _this.teachers = teachers;
    });

    this.schoolName = school.get().name;
  }

  _createClass(AdminOneSchoolController, [{
    key: 'reportError',
    value: function reportError(msg) {
      this._.msgService.displayErrorMsg(msg);
    }
  }, {
    key: 'create',
    value: function create($event) {
      var _this2 = this;

      this._.fPrompt({
        title: "What is the teacher's email address?",
        label: 'Email',
        action: 'Save'
      }, $event).then(function (email) {
        _this2.school.addTeacher(email).then(function (teacher) {
          if (teacher.email) {
            _this2.teachers.push(teacher);
            return Promise.resolve();
          }

          return Promise.reject();
        }).catch(function () {
          _this2.reportError('Could not find account with email: ' + email);
        });
      });
    }
  }, {
    key: 'remove',
    value: function remove(teacher) {
      var _this3 = this;

      this.school.rmTeacher(teacher.id).then(function () {
        _this3.teachers.splice(_this3.teachers.indexOf(teacher), 1);
      }).catch(function () {
        _this3.reportError('Teacher ' + teacher.fname + ' ' + teacher.fname + ' cannot be deleted.');
      });
    }
  }]);

  return AdminOneSchoolController;
}();

exports.default = angular.module('ifeis.routes.admin.schools.one', ['ui.router', 'ngMaterial']).config(function ($stateProvider) {
  $stateProvider.state('admin.schools.one', {
    url: '/:sid',
    template: require('./tpl.html'),
    controller: 'AdminOneSchoolController',
    controllerAs: 'admin_one_school',
    resolve: {
      school: function school(fSchoolService, $stateParams) {
        return fSchoolService.one($stateParams.sid);
      }
    },
    ncyBreadcrumb: {
      label: '{{ admin_one_school.schoolName }}'
    }
  });
}).controller('AdminOneSchoolController', AdminOneSchoolController);


//////////////////
// WEBPACK FOOTER
// ./routes/admin/schools/one/index.js
// module id = 517
// module chunks = 0